import React, { useEffect, useState } from "react";
import { FaStar, FaRegStar, FaQuoteLeft, FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { fetchAllReviews, fetchReviewSummary, addOrUpdateReview } from "../services/reviewService";
import AddReviewModal from "./review/AddReviewModal";

const TestimonialsSection = () => {
  const isMobile = window.innerWidth <= 768;
  const [reviews, setReviews] = useState([]);
  const [summary, setSummary] = useState({ averageRating: 0, totalReviews: 0 });
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("token");

  useEffect(() => {
    const load = async () => {
      try {
        const [r, s] = await Promise.all([fetchAllReviews(), fetchReviewSummary()]);
        console.log("[Testimonials] reviews:", r);
        console.log("[Testimonials] summary:", s);
        setReviews(r.data || []);
        setSummary(s.data || { averageRating: 0, totalReviews: 0 });
      } catch (e) {
        console.error("[Testimonials] error:", e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleSubmit = async ({ rating, review }) => {
    await addOrUpdateReview({ rating, review });
    setShowModal(false);
  };

  return (
    <section style={{
      padding: isMobile ? "50px 16px" : "80px 20px",
      background: "linear-gradient(135deg, #e8f8fa, #ffffff)",
      textAlign: "center",
    }}>

      <h2 style={{ fontSize: isMobile ? "1.6rem" : "2rem", marginBottom: 8 }}>
        What Our Learners Say
      </h2>

      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 6, marginBottom: 28 }}>
        {[1,2,3,4,5].map(i => i <= Math.round(summary.averageRating)
          ? <FaStar key={i} size={18} color="#FFD700" />
          : <FaRegStar key={i} size={18} color="#FFD700" />
        )}
        <span style={{ fontWeight: 700, color: "#333", marginLeft: 4 }}>
          {Number(summary.averageRating).toFixed(1)}
        </span>
        <span style={{ color: "#888", fontSize: 14 }}>
          ({summary.totalReviews} reviews)
        </span>
      </div>

      {/* Cards */}
      {loading && <p style={{ color: "#aaa" }}>Loading reviews...</p>}

      {!loading && reviews.length === 0 && (
        <p style={{ color: "#888", marginBottom: 24 }}>No reviews yet. Be the first!</p>
      )}

      {!loading && reviews.length > 0 && (
        <div style={{
          display: "flex",
          gap: 20,
          overflowX: "auto",
          padding: "8px 8px 16px",
          scrollbarWidth: "none",
          justifyContent: "center",
        }}>
          {reviews.map((r) => (
            <div key={r.id} style={{
              minWidth: 260,
              maxWidth: 260,
              flexShrink: 0,
              background: "#fff",
              borderRadius: 12,
              padding: 20,
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
              gap: 10,
            }}>
              <FaQuoteLeft size={16} color="#00a8cc" />
              <p style={{ fontSize: 14, color: "#555", lineHeight: 1.6, margin: 0 }}>
                {r.review || "—"}
              </p>
              <div style={{ display: "flex", gap: 2 }}>
                {[1,2,3,4,5].map(i => i <= r.rating
                  ? <FaStar key={i} size={13} color="#FFD700" />
                  : <FaRegStar key={i} size={13} color="#FFD700" />
                )}
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontWeight: 700, fontSize: 13, color: "#222", display: "flex", alignItems: "center", gap: 5 }}>
                  {r.userName || "User"}
                  {r.verified && <FaCheckCircle size={11} color="#019095" />}
                </span>
                <span style={{ fontSize: 12, color: "#aaa" }}>
                  {new Date(r.createdAt).toLocaleDateString("en-IN", { month: "short", year: "numeric" })}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Buttons */}
      <div style={{ display: "flex", justifyContent: "center", gap: 16, marginTop: 28, flexWrap: "wrap" }}>
        <button
          onClick={() => isLoggedIn ? setShowModal(true) : navigate("/login")}
          style={{
            padding: "10px 28px", borderRadius: 999, border: "none",
            cursor: "pointer", fontWeight: 700, fontSize: 15,
            background: "linear-gradient(135deg, #02667c, #019095)", color: "#fff",
          }}
        >
          ✍️ Add Your Review
        </button>
        <button
          onClick={() => navigate("/reviews")}
          style={{
            padding: "10px 28px", borderRadius: 999,
            border: "2px solid #019095", cursor: "pointer",
            fontWeight: 700, fontSize: 15, background: "transparent", color: "#019095",
          }}
        >
          See All Reviews →
        </button>
      </div>

      <AddReviewModal
        open={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleSubmit}
      />
    </section>
  );
};

export default TestimonialsSection;
